import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLiveCasinoState } from './use-live-casino-state.hook';
import { useAsgActions } from '../../../shared/src/hooks/use-asg-actions.hook';
import { GamesService } from '../../../shared/src/services/games.service';
import { AsgDictionaryContext, AsgFwContext } from '../contexts';

export const useRenderCasinoThumbnail = () => {
    const AsgFW = useContext(AsgFwContext);
    const Dictionary = useContext(AsgDictionaryContext);
    const { goTo, loadGame } = useAsgActions();
    const {
        session,
        balance: {
            Currency,
            CurrencySign,
        },
        recentGames,
    } = useSelector((state) => state.player);
    const {
        isMobile,
        regulation,
    } = useSelector((state) => state.app);
    const dispatch = useDispatch();
    const { buyWin, gamesById } = useSelector(state => state.casino);
    const [liveCasinoData, setLiveCasinoData] = useState(null);

    // get live casino data
    useLiveCasinoState(setLiveCasinoData);

    return function RenderCasinoThumbnail(gameId, additionalProps = {}) {
        const game = gamesById?.[gameId];
        if (!game) {
            return null;
        }

        const { GameThumbnail, props } = GamesService.getGameThumbnailComponent({
            game,
            AsgFW,
            regulation,
            currencyCode: Currency,
            currencySign: CurrencySign,
            Dictionary,
            liveCasinoData,
            isLoggedIn: !!session,
            isMobile,
            recentGames,
            loadGameAction: loadGame,
            goToAction: goTo,
            buyWinExcludedSubProviders: buyWin?.excludedSubProviders,
            dispatch,
        });

        const allProps = {
            ...props,
            ...additionalProps,
        };

        return (
            <GameThumbnail key={gameId} {...allProps} />
        );
    };
};
